import React from "react";

import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";
import Pattern from "./Pattern";

const ModelExportImage = props => {
  const { modelExport: { id, surfaceId, patternId, patternConfig } } = props;
  const { imagePanel } = surfacesByIds[surfaceId] || {};
  const pattern = patternsByIds[patternId];

  return (
    <div className="js-puppeteer model-export-image" style={{ width: "1200px" }}>
          <Pattern
            keySeed={id}
            config={patternConfig}
            pattern={pattern}
            pngexport
          />
          <img src={imagePanel} alt="" />
    </div>
  );
};

export default ModelExportImage;



// WEBPACK FOOTER //
// ./src/components/ModelExportImage.js